import { render, staticRenderFns } from "./CertificationDetail.vue?vue&type=template&id=0bd3448c&"
import script from "./CertificationDetail.vue?vue&type=script&lang=js&"
export * from "./CertificationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports